import { toQuestionTO, type QuestionTO } from './Question';

export interface QuestionnaireTO {
  id: number;
  type: string;
  title: string;
  version: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  tenancyId: number;
  questions: QuestionTO[];
}

export const toQuestionnaireTO = (questionnaire: any): QuestionnaireTO => {
  return {
    id: questionnaire.id,
    type: questionnaire.type,
    title: questionnaire.title,
    version: questionnaire.version,
    note: questionnaire.note,
    createdAt: questionnaire.created_at,
    updatedAt: questionnaire.updated_at,
    tenancyId: questionnaire.tenancy_id,
    questions: questionnaire.questions.map(toQuestionTO),
  };
};
